import type { FaireProductEntity } from "../../entity_types/product";

export const p_s4gmn5srsw: FaireProductEntity = {
  token: "p_s4gmn5srsw",
  type: "product",
  name: "Natural Stone 7 Chakra (11”)",
  brandToken: "b_ftaz83cznh",
  brandName: "Ancientveda",
  imageUrl:
    "https://cdn.faire.com/fastly/9f2e8b7356dfc3283bfbce19c0a5f5915f346d4267627d6fe1f8fdfac2521d14.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.64,
  description:
    "Explore a sacred realm of divine Indian gods and divination figurines. Immerse yourself in the ancient wisdom and spiritual energy that these meticulously crafted treasures possess. Each deity intricately depicted, these figurines invoke a sense of reverence and connection to the divine. Embrace the essence of Indian culture and invite blessings into your space with these exquisite representations of the gods and the art of divination.",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:54.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
